import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const submitChargeCardPaymentOption = gql`
  mutation SubmitChargeCardPaymentOption(
    $idempotencyId: IdempotencyToken!
    $input: SubmitChargeCardPaymentOptionInput!
  ) {
    submitChargeCardPaymentOption(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      __typename
      ... on SubmitChargeCardPaymentOptionSuccess {
        title
        message
      }
      ... on SubmitChargeCardPaymentOptionError {
        ...error
      }
    }
  }
  ${error}
`;

export default submitChargeCardPaymentOption;
